var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeemgIconsGoback202365(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.55 9.31001H7.78001L9.42001 7.67001C9.57001 7.52001 9.57001 7.27001 9.42001 7.12001C9.35001 7.05001 9.25001 7.01001 9.15001 7.01001C9.05001 7.01001 8.95001 7.05001 8.88001 7.12001L6.51001 9.49001V9.46001V9.38001V9.48001L6.50001 9.50001L6.46001 9.61001C6.46001 9.62001 6.45001 9.66001 6.45001 9.69001C6.45001 9.73001 6.45001 9.76001 6.47001 9.81001L6.54001 9.94001L8.87001 12.27C8.94001 12.34 9.04001 12.38 9.14001 12.38C9.24001 12.38 9.34001 12.34 9.41001 12.27C9.56001 12.12 9.56001 11.87 9.41001 11.72L7.77001 10.08H12.53C12.74 10.08 12.92 9.91001 12.92 9.69001C12.94 9.48001 12.76 9.31001 12.55 9.31001Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.67 6.75C16.29 5.85 15.74 5.04 15.05 4.35C14.36 3.66 13.55 3.11 12.65 2.73C11.72 2.33 10.73 2.13 9.71 2.13C8.69 2.13 7.7 2.33 6.77 2.73C5.87 3.11 5.06 3.66 4.37 4.35C3.68 5.04 3.13 5.85 2.75 6.75C2.33 7.69 2.13 8.68 2.13 9.7C2.13 10.72 2.33 11.71 2.72 12.64C3.1 13.54 3.65 14.35 4.34 15.04C5.03 15.73 5.84 16.28 6.74 16.66C7.67 17.05 8.66001 17.25 9.68001 17.25C10.7 17.25 11.69 17.05 12.62 16.66C13.52 16.28 14.33 15.73 15.02 15.04C15.71 14.35 16.26 13.54 16.64 12.64C17.03 11.71 17.23 10.72 17.23 9.7C17.26 8.68 17.06 7.69 16.67 6.75ZM16.4 9.7C16.4 13.4 13.39 16.41 9.69 16.41C5.99 16.41 2.99 13.4 2.99 9.7C2.99 6 6 2.99 9.7 2.99C13.4 2.99 16.4 6 16.4 9.7Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeemgIconsGoback202365);
export default __webpack_public_path__ + "static/media/beemg-icons-goback-2023-65.8ff2cbe20503c20eebfb55fee764cf56.svg";
export { ForwardRef as ReactComponent };